
import Vue from 'vue'
// import { QInput, QSelect } from 'quasar'
import gql from 'graphql-tag'
import types from '@/helpers/types'
import states from '@/helpers/states'
import EntryEdit from './EntryEdit.vue'
import StateChooser from './StateChooser.vue'
import format from 'date-fns/format'
import deLocale from 'date-fns/locale/de'
import distanceInWordsStrict from 'date-fns/distance_in_words_strict'
import addSeconds from 'date-fns/add_seconds'

export default Vue.extend({
    components: { EntryEdit, StateChooser },
    props: {
        entry: {
          type: Object
        },
        listId: {
          type: String
        },
        users: {
          type: Array,
          default: () => ([])
        },
        isCallDialog: {
          type: Boolean,
          default: true
        }
    },
    data() {
      return {
        entryClone: <{[key: string]: string}>{},
        isLoading: false,
        selectedState: '',
        stateComment: '',
        statePauseDuration: 0
      }
    },
    mounted() {
      const fields = [
        'name',
        'mail',
        'type',
        'tel',
        'contactPerson',
        'website',
        'postcode',
        'city',
        'address',
        'responsible',
        'products',
        'comment'
      ]
      // this.entryClone = {}
      for(let key of fields) {
        Vue.set(this.entryClone, key, this.entry[key])
      }
    },
    computed: <any>{
        stateDef() {
            return states[this.entry.lastState.key]
        },
        dateFormatted() {
            return format(this.entry.lastState.date, 'dddd, YYYY-MM-DD HH:mm', {
                locale: deLocale
            })
        },
        dateDistance() {
            return distanceInWordsStrict(new Date, this.entry.lastState.date,  {
                locale: deLocale,
                addSuffix: true
            })
        }
    },
    methods: {
      async updateState(key: string, pauseDuration: number=0, comment: string = '') {
        let pauseUntil: Date|null = null
        if(pauseDuration === Infinity) pauseUntil = new Date("2100-01-01")
        else if(pauseDuration) pauseUntil = addSeconds(new Date, pauseDuration)

        await this.$apollo.mutate({
          mutation: gql`
            mutation updateState ($id: String!, $key: String!, $listId: String!, $pauseUntil: DateTime, $comment: String) {
              updateState(
                key: $key
                listId: $listId
                id: $id
                pauseUntil: $pauseUntil
                comment: $comment
              ) {
                id
              }
            }
          `,
          variables: {
            id: this.entry.id,
            key: key,
            listId: this.listId,
            pauseUntil: pauseUntil,
            comment: comment
          }
        })
      },
      async notReached() {
        this.isLoading = true
        try {
          await this.updateState('notreached')
          this.$emit('closeDialog')
        } catch(err) {
          console.error(err)
        } finally {
          this.isLoading = false
        }
      },
      async submit(e: any) {
        if(e.shiftKey) return // don't submit on Shift+Enter        
        if(!this.selectedState) return
        this.isLoading = true

        try {
          const res = await this.$apollo.mutate({
            mutation: gql`
              mutation update ($id: String!, $data: EntryUpdateInput!, $listId: String!) {
                updateEntry(data: $data, listId: $listId, id: $id) {
                  id
                }
              }
            `,
            variables: {
              id: this.entry.id,
              data: this.entryClone,
              listId: this.listId 
            }
          })
          await this.updateState(this.selectedState, this.statePauseDuration, this.stateComment)
          this.$emit('closeDialog') 
          this.isLoading = false
        } catch(err) {
          this.isLoading = false
          console.log(err)
        }
      }
    }
})

